var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: '#about', offset: -50}),expression:"{el: '#about', offset: -50}"}],attrs:{"id":"click-me"}},[_c('p',[_vm._v("Dowiedz się więcej")]),_c('div',{attrs:{"id":"arrow"}})])}
var staticRenderFns = []

export { render, staticRenderFns }